import React, { useState } from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";

import IconUploadFile from "../../../../../../../../components/Generic/Icons/IconUploadFile";
import { useAppState } from "../../../../../../../../context/StateContext";
import { useUploadCentreAction } from "../../../../../../../../hooks/useUploadCentreAction";
import useUploadCentreContext from "../../../../../../../../hooks/useUploadCentreContext";
import { FileStatus, UploadCentreUploadedBy } from "../../../../../../../../util/enums";
import { BadgeCVSUpload } from "../BadgeCSVUpload";
import { UploadErrorModal } from "../UploadErrorModal";
import { ColumnsValues } from "../UploadModal/getInputValidation";
import { InputModal } from "../UploadModal/inputModal";
import {
  UploadDocumentButton,
  UploadItemInfos,
  UploadItemTitle,
  UploadItemWrapper,
} from "./styles";
import { isShowAction } from "Util/permissions";

interface IUploadItem {
  columnName: ColumnsValues;
  label: string;
  itemStatusKey: number;
  itemLabelId: number;
  permission?: {
    edit: boolean;
  };
}

export const UploadItem = ({
  columnName,
  label,
  itemStatusKey,
  itemLabelId,
  permission,
}: IUploadItem) => {
  const [isOpenUploadModal, setIsOpenUploadModal] = useState<boolean>(false);
  const [isOpenUploadErrorModal, setIsOpenUploadErrorModal] = useState<boolean>(false);
  const { csvName, uploadedDataError, setUploadedDataCSV } = useUploadCentreContext();
  const { t: translate } = useTranslation();

  const { currentUser } = useAppState();

  const { fetchUploadCentreItemsStatus } = useUploadCentreAction();

  const handleOpenModal = () => {
    setIsOpenUploadModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenUploadModal(false);
  };

  const onRequestSuccess = () => {
    setIsOpenUploadModal(false);
    setUploadedDataCSV([]);
    if (itemLabelId) {
      fetchUploadCentreItemsStatus();
    }
  };

  const onClickTryAgain = () => {
    setIsOpenUploadErrorModal(false);
    setIsOpenUploadModal(true);
  };

  const renderItemStatus = (itemStatusKey?: number) => {
    switch (itemStatusKey) {
      case UploadCentreUploadedBy.SHIPEEZI_DEFAULT:
        return <BadgeCVSUpload value={FileStatus.SHIPEEZI_DEFAULT} />;
      case UploadCentreUploadedBy.UPLOADED_BY_ONBOARDING:
        return <BadgeCVSUpload value={FileStatus.CSV_UPLOADED} />;
      case UploadCentreUploadedBy.UPLOADED_BY_UPLOAD_CENTRE:
        return <BadgeCVSUpload value={FileStatus.CSV_UPLOADED} />;
      default:
        return <BadgeCVSUpload value={FileStatus.SHIPEEZI_DEFAULT} />;
    }
  };

  return (
    <>
      <UploadItemWrapper>
        <UploadItemInfos>
          <UploadItemTitle>
            <span>•</span>
            <span>{translate(label)}</span>
          </UploadItemTitle>
          {renderItemStatus(itemStatusKey)}
        </UploadItemInfos>
        {permission && isShowAction(currentUser, permission?.edit) && (
          <UploadDocumentButton onClick={() => handleOpenModal()}>
            <IconUploadFile height={24} width={24} color={colors.brandBlue500} />
          </UploadDocumentButton>
        )}
      </UploadItemWrapper>
      <InputModal
        isOpenUploadModal={isOpenUploadModal}
        setIsOpenUploadModal={setIsOpenUploadModal}
        isOpenUploadErrorModal={isOpenUploadErrorModal}
        setIsOpenUploadErrorModal={setIsOpenUploadErrorModal}
        columnType={columnName}
        title={label}
        handleCloseModal={() => handleCloseModal()}
        itemLabelId={itemLabelId}
        onRequestSuccess={onRequestSuccess}
        currentUser={currentUser}
      />
      <UploadErrorModal
        isOpen={isOpenUploadErrorModal}
        uploadDataError={uploadedDataError}
        fileName={csvName}
        onClose={() => setIsOpenUploadErrorModal(false)}
        onEditFile={() => {
          onClickTryAgain();
        }}
      />
    </>
  );
};
